import http from '@http';
import apis from './apis';

const axios = http();

export default class SystemService {
    // 参加活动
    static addActive(params) {
        return axios.post(apis.addActive, params);
    }

}